import Vue from 'vue'
import VueFirestore from 'vue-firestore'
import * as firebase from 'firebase'
import '@firebase/firestore'
import firebaseConfig from './firebaseConfig'
Vue.use(VueFirestore)

const firebaseApp = firebase.initializeApp(firebaseConfig)

// const firestore = firebaseApp.firestore()
Vue.prototype.$fb = firebase
Vue.prototype.$db = firebase.firestore()

const signUserIn = ({commit}, payload) => {
  commit('setLoading', true)
  commit('clearError')
  console.log('fbinit')
  console.log(this.$fb)
  this.$fb.auth().signInWithEmailAndPassword(payload.email, payload.password).then(user => {
    console.log(user.uid)
    this.$db.collection('userMeta').where('userId', '==', user.uid).get().then((querySnapshot) => {
      this.loading = false
      querySnapshot.forEach((doc) => {
        if (doc.data().approved) {
          let newUser = {
            'id': user.uid,
            'firstName': doc.data().firstName,
            'lastName': doc.data().lastName,
            'email': doc.data().email,
            'telephone': doc.data().telephone,
            'address1': doc.data().address1,
            'address2': doc.data().address2,
            'town': doc.data().town,
            'county': doc.data().county,
            'postcode': doc.data().postcode
          }
          this.$store.dispatch('setUser', newUser)
        } else {
          console.log('your are not approved')
        }
      })
    }).catch(error => {
      console.log(error)
    })
  }).catch(error => {
    console.log(error)
  })
}

export default {firebaseApp, signUserIn}



// WEBPACK FOOTER //
// ./src/modules/firebase/firebaseInit.js